import TechBanner from "./TechBanner/TechBanner";

export default TechBanner;

export { default as ServiceTabs } from './ServiceTabs/ServiceTabs';
export { default as TechRatingBadge } from './TechRatingBadge';
